import { render, staticRenderFns } from "./EditGenou.vue?vue&type=template&id=67a7d11c&scoped=true&"
import script from "./EditGenou.vue?vue&type=script&lang=js&"
export * from "./EditGenou.vue?vue&type=script&lang=js&"
import style0 from "./EditGenou.vue?vue&type=style&index=0&id=67a7d11c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7d11c",
  null
  
)

export default component.exports